import { Card, Skeleton } from '@pmi/dsm-react';
import {
  AutoCompleteIcon,
  MinusIcon,
} from '@pmi/dsm-react/dist/components/icons/16';

import './dataCard.scss';
import { ReactElement } from 'react';

export enum DataCardDataState {
  Up = 0,
  Down = 1,
  Neutral = 2,
}

export interface DataCardFootNoteProp {
  dataState: DataCardDataState;
  value: number;
  text: string;
}

export interface DataCardProp {
  title: string | ReactElement;
  total: number | string;
  footNote?: DataCardFootNoteProp | null;
  className?: string | undefined;
  loading?: boolean;
}
export default function DataCard({
  title,
  total = 0,
  footNote = null,
  className = undefined,
  loading = false,
}: DataCardProp) {
  const footNoteContent = ({
    value,
    dataState,
    text,
  }: DataCardFootNoteProp) => {
    const iconDiscretionary = [
      <AutoCompleteIcon
        color="success"
        className="data-card__ArrowDown"
        fontSize="xs"
      />,
      <AutoCompleteIcon
        color="danger"
        className="data-card__ArrowUp"
        fontSize="xs"
      />,
      <MinusIcon fontSize="xs" />,
    ];

    const valueBlock = () => {
      switch (dataState) {
        case DataCardDataState.Up:
          return <span className="d-inline text-success">+{value}</span>;
        case DataCardDataState.Down:
          return <span className="d-inline text-danger">-{value}</span>;
        default:
          return null;
      }
    };

    return (
      <div>
        <span className="d-inline me-1">{iconDiscretionary[dataState]}</span>
        {valueBlock()}
        <span className="d-inline ms-1" title={text}>
          {text}
        </span>
      </div>
    );
  };

  return (
    <Card className={`${className} item-card p-md-3 p-2`}>
      <h6 className="data-card__Title">{title}</h6>
      {loading ? (
        <Skeleton className="mt-2" animation="wave" height={40} width="40%" />
      ) : (
        <h3 className="data-card__Total">{total}</h3>
      )}
      {footNote && (
        <div className="d-flex align-content-center align-items-center data-card__FootNote">
          {footNoteContent(footNote)}
        </div>
      )}
    </Card>
  );
}
